module.exports = __webpack_public_path__ + "img/sunshine_460.14737abb.png";